import { render, staticRenderFns } from "./activityManagement.vue?vue&type=template&id=476d2603&scoped=true"
import script from "./activityManagement.vue?vue&type=script&lang=js"
export * from "./activityManagement.vue?vue&type=script&lang=js"
import style0 from "./activityManagement.vue?vue&type=style&index=0&id=476d2603&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d2603",
  null
  
)

export default component.exports